import type { RouteObject } from "react-router-dom";
import { PATH as ADMIN_TOOLS_PATH } from "./pages/tools/AdminToolsPage";
import { PATH as ADMIN_GENERATOR_PATH } from "./pages/generator/AdminGeneratorPage";

export const ADMIN_ROUTES: RouteObject[] = [
  {
    path: "reports",
    children: [
      {
        path: ":id",
        lazy: async () => {
          const { ReportDetailsPageWrapper } = await import(
            "./pages/report/details/ReportDetailsPageWrapper"
          );
          return { Component: ReportDetailsPageWrapper };
        },
        children: [
          {
            path: ":tabId",
            lazy: async () => {
              const { ReportDetailsPage } = await import(
                "./pages/report/details/ReportDetailsPage"
              );
              return { Component: ReportDetailsPage };
            },
          },
          {
            index: true,
            lazy: async () => {
              const { ReportDetailsPage } = await import(
                "./pages/report/details/ReportDetailsPage"
              );
              return { Component: ReportDetailsPage };
            },
          },
        ],
      },
      {
        index: true,
        lazy: async () => {
          const { ReportListPage } = await import(
            "./pages/report/ReportListPage"
          );
          return { Component: ReportListPage };
        },
      },
    ],
  },
  {
    path: "audit",
    lazy: async () => {
      const { AuditLogPage } = await import("./pages/AuditLogPage");
      return { Component: AuditLogPage };
    },
  },
  {
    path: "alerts",
    lazy: async () => {
      const { AdminAlertsPage } = await import("./pages/AdminAlertsPage");
      return { Component: AdminAlertsPage };
    },
  },
  {
    path: "messages",
    lazy: async () => {
      const { QueryMessagesPage } = await import(
        "./pages/messages/QueryMessagesPage"
      );
      return { Component: QueryMessagesPage };
    },
  },
  {
    path: "polling-jobs",
    children: [
      {
        path: ":id",
        lazy: async () => {
          const { PollingJobPage } = await import(
            "./pages/polling-jobs/PollingJobPage"
          );
          return { Component: PollingJobPage };
        },
      },
      {
        index: true,
        lazy: async () => {
          const { PollingJobsPage } = await import(
            "./pages/polling-jobs/PollingJobsPage"
          );
          return { Component: PollingJobsPage };
        },
      },
    ],
  },
  {
    path: "aggregate",
    children: [
      {
        index: true,
        lazy: async () => {
          const { AggregatePage } = await import(
            "./pages/aggregate/AggregatePage"
          );
          return { Component: AggregatePage };
        },
      },
      {
        path: ":tabId",
        lazy: async () => {
          const { AggregatePage } = await import(
            "./pages/aggregate/AggregatePage"
          );
          return { Component: AggregatePage };
        },
      },
      {
        path: "counter/:counter",
        lazy: async () => {
          const { AggregateRangePage } = await import(
            "./pages/aggregate/AggregateRangePage"
          );
          return { Component: AggregateRangePage };
        },
      },
    ],
  },
  {
    path: "lookup/token/:token",
    lazy: async () => {
      const { LookupReportByToken } = await import(
        "./pages/report/LookupReportByToken"
      );
      return { Component: LookupReportByToken };
    },
  },
  {
    path: ADMIN_TOOLS_PATH,
    lazy: async () => {
      const { AdminToolsPage } = await import("./pages/tools/AdminToolsPage");
      return { Component: AdminToolsPage };
    },
  },
  {
    path: ADMIN_GENERATOR_PATH,
    children: [
      {
        index: true,
        lazy: async () => {
          const { AdminGeneratorPage } = await import(
            "./pages/generator/AdminGeneratorPage"
          );
          return { Component: AdminGeneratorPage };
        },
      },
      {
        path: ":tabId",
        lazy: async () => {
          const { AdminGeneratorPage } = await import(
            "./pages/generator/AdminGeneratorPage"
          );
          return { Component: AdminGeneratorPage };
        },
      },
    ],
  },
  {
    lazy: async () => {
      const { LandingPage } = await import("./pages/LandingPage");
      return { Component: LandingPage };
    },
    index: true,
  },
];
